module.exports = __webpack_public_path__ + "img/cgv_mobile.710e3279.jpg";